import {AxiosResponse} from 'axios';
import {axiosInstance} from '..';

export function getUsers(roleId?: number, enabled?: boolean): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`User/List`, {
    params: { 
      roleId,
      enabled
     },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}


export function createUser(data: any): Promise<AxiosResponse<any, any>> {
  return axiosInstance.post('User/Register', data, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function updateUser(userId: number, data: any): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`User/UpdateUser/${userId}`, data, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getUserByEmail(email: string): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`User/GetByEmail/${email}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}

export function uploadUsersExcel(file: File, roleId: number): Promise<AxiosResponse<any, any>> {
  const formData = new FormData();
  formData.append('file', file);
  
  return axiosInstance.post(`User/UploadUsers/${roleId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}


export function softDeletePreUsers(userIds: number[]): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put('User/SoftdeletePreUsers', {
    userIds: userIds
  }, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function softDeleteUser(userId: number): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`User/SoftdeleteUser/${userId}`, {}, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}


export function generateCode(userId: number): Promise<AxiosResponse<any, any>> {
  return axiosInstance.post(`User/GenerateCode/${userId}`, {}, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function sendRecoveryEmail(email: string): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`User/SendMail/${encodeURIComponent(email)}`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function recoverPassword(userId: number, data: {password: string}): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`User/RecoverPassword/${userId}`, data, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function ValidateCode(code: number): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`User/ValidateCode/${code}`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function FirstLogin(token: string, data: { password: string }): Promise<AxiosResponse<any, any>> {
  return axiosInstance.post(`User/FirstLogin/${token}`, data, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function disableUser(userId: number): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`User/DisableUser/${userId}`, {}, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function downloadExcelTemplate(roleId: number): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`User/ExportDownloadExcel/${roleId}`, {
    responseType: 'blob', 
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
  });
}

export function downloadUsersExcelData(roleId: number, enabled?: boolean): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`User/ExcelUsersData`, {
    params: {
      roleId: roleId,
      enabled_user: enabled
    },
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
  });
}
export function getUsersBySupplierType(criticity?: string[]): Promise<AxiosResponse<any, any>> {
  const params = new URLSearchParams();
  
  if (criticity && criticity.length > 0) {
    criticity.forEach(value => {
      params.append('criticity', value);
    });
  }
  
  return axiosInstance.get(`User/GetusersBySupplierType`, {
    params: params, 
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getUsersBySearch(searchName: string, roleId?: number): Promise<AxiosResponse<any, any>> {
  const params = new URLSearchParams();
  
  if (searchName) {
    params.append('searchName', searchName);
  }
  
  if (roleId) {
    params.append('roleId', roleId.toString());
  }
  
  return axiosInstance.get(`User/List`, {
    params: params,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getUser(userId: number): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`User/GetUser/${userId}`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}
export function getUserData(userId: string | number): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`User/GetUser/${userId}`, {
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
    });
}